
<template>
    <component
        :is="dialogName"
        :open.sync="open"
        :data="data"
    />
</template>

<script>
import {READ, UNREAD} from '@/views/Message/config';
import {mapMutations, mapActions} from 'vuex';
import RichTextDialog from './RichTextDialog.vue';
import OfflinePayDialog from './OfflinePayDialog';
export default {
    inject: ['model', 'sendCustomEvent'],
    components: {
        RichTextDialog,
        OfflinePayDialog
    },
    data() {
        return {
            data: {},
            open: false,
            contentType: 0 // 0：富文本，1：json(线下充值到账)
        };
    },
    computed: {
        dialogName() {
            const contentTypeMap = ['RichTextDialog', 'OfflinePayDialog'];
            return contentTypeMap[this.contentType];
        }
    },
    methods: {
        ...mapMutations('message', {
            'setRefreshUserCenterMessage': 'SET_REFRESH_USER_CENTER_MESSAGE'
        }),
        ...mapActions('message', [
            'getMessages',
            'getCount'
        ]),
        async changeMessageStatus() {
            const params = {
                messagesIds: [this.data.messageId],
                changeStatus: READ
            };
            await this.model.message.changeMessagesStatus(params);
            const type = this.data.messageType === 1 ? 'system' : 'personal';
            // 若当前在消息中心页面，需要刷新对应的消息中心列表
            if (this.$route.name === 'messageCenter') {
                this.setRefreshUserCenterMessage(type);
                this.getCount({model: this.model, type});
            }
            // 刷新消息浮窗对应tab列表
            this.getMessages({type, model: this.model});
        },
        async handleClose() {
            this.open = false;
        },
        handleOk() {
            this.handleClose();
            this.$router.push({
                name: 'messageCenter',
                query: {
                    active: this.data.messageType === 1 ? 'system' : 'personal'
                }
            });
        },
        // 获取推送消息
        async getPushMessage() {
            let params = {
                filters: [
                    {'field': 'showDialog', 'op': 'eq', values: [1]},
                    {'field': 'status', 'op': 'eq', values: [UNREAD]}
                ],
                pageSize: 1,
                pageNo: 1

            };
            const data = await this.model.message.getMessageList(params);
            const list = data.listData;
            if (list?.length > 0) {
                this.data = list[0];
                this.contentType = this.data.contentType;
                this.open = true;
                this.changeMessageStatus();
                this.sendCustomEvent('触发消息弹窗');
            }
            return list?.length || 0;
        }
    },
    async mounted() {
        const num = await this.getPushMessage();
        if (num === 0) {
            // 如果mount查询了一次没有查到，后端接口有Bug、首次查询没有数据，再查询一次。
            this.getPushMessage();
        }
    }
};
</script>

<style lang="less" scoped>
.custom-dialog {
    &-header-bg {
        width: 480px;
        height: 265.5px;
        position: absolute;
        left: -24px;
        top: -24px;
        background-image: url("../../assets/messageDialogBg.png");
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
    }
    &-header-text {
        z-index: 208;
        color: var(----G9, #282C33);
        font-size: 18px;
        font-weight: 500;
        line-height: 22px; /* 137.5% */
    }
    /deep/ .veui-ai-dialog-content {
        width: 480px;
        border-radius: 16px;
        box-shadow:
            0px 4px 28px 1px rgba(0, 71, 194, 0.04),
            0px 5px 30px 1px rgba(0, 71, 194, 0.05),
            0px 6px 32px 2px rgba(0, 71, 194, 0.06);
        overflow: hidden;
    }
    /deep/ .veui-ai-dialog-content-head {
        padding-bottom: 14px;
        align-items: center;
        &-title {
            position: relative;
        }
    }
    /deep/ .veui-ai-dialog-content-foot {
        display: flex;
        flex-direction: row-reverse;
        padding-top: 22px;
        gap: 12px;
    }
    &-content {
        color: var(----G9, #282C33);
    }
    .message-content {
        position: relative;
        color: var(----G9, #282C33);
        text-align: center;
        font-size: 14px;
        line-height: 26px; /* 185.714% */
        white-space: pre-wrap;
        /deep/ a {
            color: #3A5BFD;
            white-space: nowrap;
        }
    }

}
</style>
